const DRAFT_MESSAGE_KEY_PREFIX = 'draft_message';
const LAST_ORGANIZATION_KEY_PREFIX = 'last-organization';
const SEND_OPERATION_KEY_PREFIX = 'line-ban:send-operation';
export const DISPATCH_ACKNOWLEDGED_KEY_PREFIX =
  'line-ban:line-dispatch:acknowledged:v1';

export type SendOperationKind = 'bulk' | 'test';

export function draftMessageStorageKey(
  uid: string,
  organizationId: number,
): string {
  return `${DRAFT_MESSAGE_KEY_PREFIX}:${uid}:${organizationId}`;
}

export function dispatchAcknowledgedStorageKey(
  uid: string,
  organizationId: number,
): string {
  return `${DISPATCH_ACKNOWLEDGED_KEY_PREFIX}:${uid}:${organizationId}`;
}

export function buildSendOperationOwnerKey(
  uid: string,
  organizationId: number,
): string {
  return `${uid}:${organizationId}`;
}

/**
 * 送信操作 identity の保存キー。
 * 他組織の未確認 operation を上書きしないよう ownerKey（uid:orgId）を含める。
 */
export function sendOperationStorageKey(
  kind: SendOperationKind,
  ownerKey: string,
): string {
  return `${SEND_OPERATION_KEY_PREFIX}:${kind}:v1:${ownerKey}`;
}

/** 組織スコープ導入前のグローバルキー（移行元）。 */
export function legacySendOperationStorageKey(
  kind: SendOperationKind,
): string {
  return `${SEND_OPERATION_KEY_PREFIX}:${kind}:v1`;
}

export function lastOrganizationStorageKey(uid: string): string {
  return `${LAST_ORGANIZATION_KEY_PREFIX}:${uid}`;
}

export function readLastOrganizationId(uid: string): number | null {
  try {
    const raw = localStorage.getItem(lastOrganizationStorageKey(uid));
    if (!raw) return null;
    const parsed = Number(raw);
    return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : null;
  } catch {
    return null;
  }
}

export function writeLastOrganizationId(
  uid: string,
  organizationId: number,
): void {
  try {
    localStorage.setItem(
      lastOrganizationStorageKey(uid),
      String(organizationId),
    );
  } catch {
    // ストレージが使えない環境では記録せずに続行する
  }
}
